import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./login.css";

const AuthLayout = () => {
	useEffect(() => {
		const root = document.getElementById("root");
		if (root) {
			root.style.height = "100%";
		}
		return () => {
			if (root) {
				root.style.height = "auto";
			}
		};
	}, []);

	return (
		<div className="d-flex flex-column flex-lg-row flex-column-fluid  login-bg">
			{/* begin::Body */}
			<div className="d-flex flex-column flex-lg-row-fluid w-lg-50  order-2 order-lg-1">
				{/* begin::Form */}
				<div className="d-flex flex-center flex-column flex-lg-row-fluid">
					{/* begin::Wrapper */}
					<div>
						<Outlet />
					</div>
					{/* end::Wrapper */}
				</div>
				{/* end::Form */}
			</div>
			{/* end::Body */}
		</div>
	);
};

export { AuthLayout };
